import React, { useRef, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Link } from 'react-scroll';
import backgroupImage from '../../img/Background-Redes.png'
import LoadingGif from '../../img/GIF.gif';

// Components ------------------------------------------------------//
import ProfileAllocationSection from "./profile-allocation";
import ProfileBuilderSection from "./profile-builder";
import { Button, Segment } from "../../presenters";
import DEFAULT_ALLOCATIONS from "../../default-allocations";
import ALLOCATION_CLASSES from '../../allocation-classes';
import axios from "axios";
import { useLocation } from 'react-router';
import queryString from 'query-string';
// CSS -------------------------------------------------------------//
import "./index.css";

// Redux ----------------------------------------------------------//
import { setParameters } from "../../redux/actions";
import { connect } from "react-redux";
import { constant } from "lodash";

const mapStateToProps = (state, ownProps) => {
    return {
        parameters: state.parameters,
    };
};

// Map dispatch to component props
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setParameters: (params) => dispatch(setParameters(params)),
    };
};

/**
 * Represents the Simulator main application page.
 * It displays the options to the user to choose the desired
 * allocation between the asset classes and to send the simulation parameters to
 * the API and start the simulation process.
 *
 * @author Giovanna Marinelli
 */
const Main = () => {
    const history = useHistory();
    // Error state
    const [error, setError] = useState(false);
    // Check first launch reload
    const [launchFirstTime, setlaunchFirstTime] = useState(true);
    // Get url GET options
    const location = useLocation();
    const param = queryString.parse(location.search)


    // Scholl page up
    const scrollPageUp = () => {
        window.scrollTo(0, 0);
    }

    const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop - 68);
    let myRef = useRef();

    /**
        * Page go top when page is first load 
        * When page load and has param reload = true in url scroll page to reference 
        */
    useEffect(() => {
        if (launchFirstTime) {
            if (param.reload === "true") {
                scrollToRef(myRef);
            } else {
                scrollPageUp();
                setlaunchFirstTime(false);
            }
        }
    }, []);


    const [allocation, setAllocation] = useState(
        DEFAULT_ALLOCATIONS["Agressiva"]
    );

    const [allocationType, setAllocationType] = useState(
        "Agressiva"
    );

    /**
        * Handle allocation changes in allocation values and type
        * 
        */
    const handleAllocationChangeDefault = (allocation, allocationType) => {
        setAllocation && setAllocation(allocation);
        setAllocationType && setAllocationType(allocationType);
    };


    /**
        * Display the buttons to choose between default
        * profiles.
        */
    const renderDefaultProfilesButtons = () => {
        // console.log(allocation)
        return (
            <div
                className="ProfileAllocation__btn-group btn-group"
                role="group"
                aria-label="Carteiras Padrão"
            >
                {Object.keys(DEFAULT_ALLOCATIONS).map((k) => (
                    <button
                        key={k}
                        type="button"
                        className={`ProfileAllocation__btn-group-btn btn btn-secondary${allocationType === k ? " active" : ""
                            }`}
                        onClick={() => handleAllocationChangeDefault(DEFAULT_ALLOCATIONS[k], k)}
                    >
                        {k}
                    </button>
                ))}
            </div>
        );
    };
    const API_URL = "https://site.pandhora.com/api";

    /**
        * Allocate and calculate the percentage of Essencial and LB based 
        * type of risk.
        * 
        */
    const portfolioWithPandhora = () => {
        const allocationNotPandhora = Object.assign({}, allocation);
        const essencial = 'pandhoraEssencial';
        const lb = "pandhoraLb";
        let pandhoraSum = 0;

        // 
        if (allocationNotPandhora[essencial] === 0 && allocationNotPandhora[lb] === 0) {
            for (const [key, value] of Object.entries(ALLOCATION_CLASSES[allocationType])) {
                pandhoraSum += value;
            }
        }

        Object.keys(allocation).reduce(
            (sum, key) => (allocationNotPandhora[key] = allocation[key] * (1 - pandhoraSum / 100.0)),
            0.0
        );

        allocationNotPandhora[essencial] = ALLOCATION_CLASSES[allocationType][essencial];
        allocationNotPandhora[lb] = ALLOCATION_CLASSES[allocationType][lb];

        return allocationNotPandhora;
    }


    /**
        * Create a dictionary of allocation to be post and perfil selected
        * 
        */
    const formatedAllocation = (_allocation) => {
        const fAllocation = {}
        Object.keys(_allocation).forEach(k => fAllocation[k] = _allocation[k] / 100.0);
        fAllocation['perfil'] = allocationType;
        return fAllocation;
    }

    /**
        * Post allocation to be saved on Database
        * 
        */
    const postAllocation = async () => {
        try {
            const url = `${API_URL}/allocation`;
            const result = await axios.post(url, formatedAllocation(portfolioWithPandhora()));
            if (result.status !== 201) {
                console.error("Whoopsie. API returned code " + result.status + " for post " + formatedAllocation(portfolioWithPandhora()))
                setError(true);
            } else {
                scrollPageUp();
                history.push("/result/" + result.data.id);
            }
        } catch (e) {
            console.error("Whoopsie!", e);
            setError(true);
        }

    };

    /**
        * Called when button "Simular" is clicked, page go up and post allocation
        * 
        */
    const onSimulationClick = () => {
        scrollPageUp();
        postAllocation();
    };

    /**
        * Reset allocation based on type of allocation selected
        * 
        */
    const onResetClick = () => {
        setAllocation(DEFAULT_ALLOCATIONS[allocationType]);
    };

    /** Render the Main page */

    return (
        <div className="Main">
            <div className="pageSimulator__banner">
                <h1>Vamos simular o <strong>impacto de <strong className="yellow">Fundo Quant</strong> na sua carteira?</strong></h1>
                <Button to="start_sim" className="button" onClick={() => scrollToRef(myRef)}>Começar</Button>
                <div className="pageSimulator__bannerImage" />
            </div>
            <Segment>
                <div id="start_sim" ref={myRef} className="row start_sim">
                    <h1>Conte para nós <strong><strong>como está sua </strong><strong className="yellow">carteira atual:</strong></strong></h1>
                </div>
                <div className="ProfileBuilder__title">Selecione seu perfil</div>
                <div className="ProfileBuilder__subtitle">Para realizar a simulação, selecione um dos perfis de carteira abaixo. <br />Se desejar, ajuste as alocações individuais em cada uma das classes de ativo simuladas.</div>
                <h2 className="ProfileBuilder__subtitle__allocation">Carteira padrão:</h2>
                <div className="row">
                    <div className="col-sm gx-5">
                        {renderDefaultProfilesButtons()}
                        <ProfileBuilderSection
                            allocation={allocation}
                            onAllocationChange={setAllocation}
                        ></ProfileBuilderSection>
                    </div>
                    <div className="col-sm gx-5 ProfileAllocationCenter">
                        <ProfileAllocationSection
                            allocation={allocation}
                            onAllocationChange={setAllocation}
                        ></ProfileAllocationSection>
                    </div>
                </div>
            </Segment>
            <div style={{ background: "#EBEBEB", width: "100%" }}>
                <div className="Main__button-container">
                    <Button onClick={onSimulationClick}>Simular</Button>
                    <Button className="reset_carteira" onClick={onResetClick}>Restaurar carteira</Button>
                </div>
            </div>

            <div className="Main__disclaimer-container">
                <div>
                    <p>As informa&ccedil;&otilde;es apresentadas neste recurso (&quot;Simulador&quot;) s&atilde;o meramente
                        ilustrativas e baseadas em dados te&oacute;ricos a partir de cotas de fundos e &iacute;ndices de
                        mercado dispon&iacute;veis publicamente. As informa&ccedil;&otilde;es presentes neste material
                        t&eacute;cnico s&atilde;o baseadas em simula&ccedil;&otilde;es e os resultados reais poder&atilde;o ser
                        significativamente diferentes. Rentabilidade obtida no passado n&atilde;o representa
                        garantia de resultados futuros. A rentabilidade divulgada n&atilde;o &eacute; l&iacute;quida de
                        impostos. O investimento em Fundo n&atilde;o &eacute; garantido pelo Fundo Garantidor de
                        Cr&eacute;dito - FGC. A Pandhora n&atilde;o comercializa ou distribui quotas de fundos de
                        investimento, portanto todas as informa&ccedil;&otilde;es contidas neste website n&atilde;o devem
                        ser consideradas como oferta de venda de cotas de fundos de investimentos ou
                        de qualquer t&iacute;tulo ou valor mobili&agrave;rio, recomenda&ccedil;&atilde;o de investimento e nem
                        devem servir como &uacute;nica base para tomada de decis&otilde;es de investimento. A
                        Pandhora Investimentos se exime de qualquer responsabilidade, direta ou indireta,
                        por todos e quaisquer preju&iacute;zos decorrentes de opera&ccedil;&otilde;es realizadas com base
                        nas informa&ccedil;&otilde;es aqui prestadas, notadamente relacionadas &agrave; decis&atilde;o de
                        investimento do cliente.</p>
                </div>
            </div>
        </div>
    );
};

// Connect Main to redux store
const ConnectedMain = connect(mapStateToProps, mapDispatchToProps)(Main);

export default ConnectedMain;
